import { CommentsService } from "../../../../services/comments.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AppSetting } from "../../../../global/appsetting";
import { LoaderService } from "../../../../services/loader.service";
import { ActivatedRoute } from "@angular/router";
import {
  GaAnalyticsService,
  EVENT_TYPES,
} from "src/app/services/ga-analytics.service";
import { Comment } from "../../../../models/comments/comments";
import { ProductDetailsUiStateService } from "../product-details-ui-state.service";

@Component({
  selector: "app-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.scss"],
})
export class CommentsComponent implements OnInit {
  productId = this._pUiService.productId;
  currentUrl = this._pUiService.currentUrl;
  stars = this._pUiService.stars;

  prodComments: Array<Comment>;
  starsArray = [1, 2, 3, 4, 5];
  facebookHtml: string;

  constructor(
    public commentsService: CommentsService,
    public loaderService: LoaderService,
    private _pUiService: ProductDetailsUiStateService,
    private route: ActivatedRoute,
    private gaAnalyticsService: GaAnalyticsService
  ) {}

  ngOnInit(): void {
    this.getAllPost();
  }

  getAllPost(): void {
    this.loaderService.displayLoader(false);
    const productId = this.route.snapshot.params.id;
    this.commentsService.GetCommentByProductID(productId).subscribe(
      (res: Array<Comment>) => {
        this.loaderService.hideLoader();
        this.prodComments = res;
      },
      (error) => {
        console.error(error);
        this.gaAnalyticsService.logEventToGa(
          "getAllPost",
          "CommentsComponent",
          EVENT_TYPES.Error
        );
      }
    );
  }

  setStar(index): void {
    this._pUiService.starsChange(index + 1);
  }

  displayCommentFormChange(val: boolean): void {
    this._pUiService.displayCommentFormChange(val);
  }
}
